import { GET_FALLBACK_LAYOUT } from '../actions/fallback';

export type State = {
  error: any;
  data: any;
  loaded: boolean;
  loading: boolean;
};

const initialState: State = {
  error: null,
  data: null,
  loaded: false,
  loading: false,
};

/**
 * Reducer for handling the fallback layout data.
 * @param state The current state.
 * @param action The action being dispatched.
 * @returns The new state.
 */
export default function fallbackLayout(
  state = initialState,
  action: any = {},
): State {
  switch (action.type) {
    case `${GET_FALLBACK_LAYOUT}_PENDING`:
      return { ...initialState, loading: true };
    case `${GET_FALLBACK_LAYOUT}_SUCCESS`:
      return {
        ...state,
        error: null,
        data: action.result,
        loaded: true,
        loading: false,
      };
    case `${GET_FALLBACK_LAYOUT}_FAIL`:
      // We don't want to clear the data if a request fails,
      // and we log the error but don't overwrite the main page error.
      return {
        ...state,
        error: action.error,
        data: null,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
